

// * @output = {
//   *      "code"                                                 (string)
//   *      "saleDate"                                             (string)
//   *      "status"                                               (string)
//   *      "trialData"                                            (object)
//   *          "trialData.discount"                               (object)
//   *              "trialData.discount._id"                       (string)
//   *              "trialData.discount.identifier"                (string)
//   *          "trialData.trialEndDate"                           (string)
//   *      "appliedCoupons"                                       ([com.sydle.billing.productCatalog.discount])
//   *      "product"                                              (object)
//   *          "product._id"                                      (string)
//   *          "product.identifier"                               (string)
//   *          "product.name"                                     (string)
//   *          "product.periodicity"                              (string)
//   *          "product.description"                              (string)
//   *          "product.category"                                 (string)
//   *          "product.externalCode"                             (string)
//   *      "paymentMethod"                                        (object)
//   *          "paymentMethod.identifier"                         (string)
//   *          "paymentMethod.paymentConditionIdentifier"         (string)
//   *          "paymentMethod.creditCard"                         (object)
//   *              "paymentMethod.creditCard.brand"               (string)
//   *              "paymentMethod.creditCard.number"              (string)
//   *      "provisioningParameters"                               (object)
//   *          "provisioningParameters.buyerName"                 (string)
//   *          "provisioningParameters.buyerEmail"                (string)
//   *          "provisioningParameters.buyerPhone"                (string)
//   *          "provisioningParameters.businessId"                (string)
//   *          "provisioningParameters.userId"                    (string)
//   * }

import { Product } from './product';

class Discount {
  _id: string;
  identifier: string;
  constructor(discountData?: any) {
    if (discountData) {
      this._id = discountData._id;
      this.identifier = discountData.identifier;
    }
  }
}

class TrialData {
  discount: Discount;
  trialEndDate: string;
  constructor(trialData?: any) {
    if (trialData) {
      this.discount = trialData.discount;
      this.trialEndDate = trialData.trialEndDate;
    }
  }
}

class CreditCard {
  brand: string;
  number: string;
  constructor(creditCardData?: any) {
    this.brand = creditCardData.brand;
    this.number = creditCardData.number;
  }
}

class PaymentMethod {
  identifier: string;
  paymentConditionIdentifier: string;
  creditCard: CreditCard;
  constructor(paymentMethodData?: any) {
    if (paymentMethodData) {
      if(paymentMethodData.identifier === 'ADYEN') {
        paymentMethodData.identifier = 'CREDIT_CARD';
      }
      
      this.identifier = paymentMethodData.identifier;
      if (paymentMethodData.identifier === 'CREDIT_CARD') {
        this.paymentConditionIdentifier = paymentMethodData.paymentConditionIdentifier;
        this.creditCard = new CreditCard(paymentMethodData.creditCard);
      }
    }
  }
}

class ProvisioningParameters {
  buyerName: string;
  buyerEmail: string;
  buyerPhone: string;
  userId: string;
  businessId: string;
  allowAutomaticRecharge: boolean;
  additionalInfo: string;

  constructor(provisioningParametersData?: any) {
    if (provisioningParametersData) {
      this.buyerEmail = provisioningParametersData.buyerEmail;
      this.buyerName = provisioningParametersData.buyerName;
      this.buyerPhone = provisioningParametersData.buyerPhone;
      this.userId = provisioningParametersData.userId;
      this.businessId = provisioningParametersData.businessId;
      this.allowAutomaticRecharge = provisioningParametersData.allowAutomaticRecharge;

      if (provisioningParametersData.additionalInfo) {
        this.additionalInfo = provisioningParametersData.additionalInfo;
      }
    }
  }
}

class AdobeAnalyticsData {
  firstPurchase: boolean;
  purchaseType: string;

  constructor(adobeData?: any) {
    if(adobeData) {
      this.firstPurchase = adobeData.firstPurchase;
      this.purchaseType = adobeData.purchaseType;
    }
  }
}

export class Contract {
  code: string;
  saleDate: string;
  endDate: string;
  status: string;
  nextRecurrenceDate: string;
  trialData: TrialData;
  appliedCoupons: Array<Discount>;
  mgmCoupon: string;
  product: Product;
  paymentMethod: PaymentMethod;
  provisioningParameters: ProvisioningParameters;
  adobeAnalyticsData: AdobeAnalyticsData;

  constructor(contractData?: any) {
    if (contractData) {
      this.code = contractData.orderCode ? contractData.orderCode : contractData.code;
      this.saleDate = contractData.saleDate;
      this.endDate = contractData.endDate;
      this.status = contractData.status;
      this.nextRecurrenceDate = contractData.nextRecurrenceDate;
      if (contractData.trialData) {
        this.trialData = new TrialData(contractData.trialData);
      }
      if (contractData.appliedCoupons && contractData.appliedCoupons.length) {
        this.appliedCoupons = contractData.appliedCoupons.map(coupon => new Discount(coupon));
      }
      if (contractData.mgmCoupon) {
        this.mgmCoupon = contractData.mgmCoupon;
      }
      if (contractData.product) {
        this.product = new Product(contractData.product);
      }
      if (contractData.paymentMethod) {
        this.paymentMethod = new PaymentMethod(contractData.paymentMethod);
      }
      if (contractData.provisioningParameters) {
        this.provisioningParameters = new ProvisioningParameters(contractData.provisioningParameters);
      }

      if(contractData.adobeAnalyticsData) {
        this.adobeAnalyticsData = new AdobeAnalyticsData(contractData.adobeAnalyticsData);
      }

    }
  }
}
